import Popup from '@/components/common/Popup/Popup.vue'
export default (Vue)=>{
  Vue.component("Popup", Popup )  // 前者必须是字符串格式
}


// WEBPACK FOOTER //
// ./src/components/common/index.js